<template>
  <HeaderCustom v-if="obra" title="Gestão do Conhecimento">
    <v-row class="ma-0 align-end justify-space-between mb-2">
      <v-col cols="6" class="pb-0 ps-0">
        <v-card-title class="px-0 pb-0">
          <v-btn icon :disabled="!canGoBack" @click="$router.back()">
            <v-icon>
              {{ mdiArrowLeft }}
            </v-icon>
          </v-btn>
          {{ obraDetails.title }}
        </v-card-title>
      </v-col>
      <SeletorOpcoesImpressao
        :items="[
          {
            text: 'Simplificado',
            value: 'S',
            icone: IconPaginaSimplificada,
          },
          {
            text: 'Detalhado',
            value: 'D',
            icone: IconPaginaDetalhada,
          },
        ]"
        @change="store.download"
      />
    </v-row>
    <template>
      <sds-card title="Informações Gerais">
        <component :is="obraDetails.component" />
      </sds-card>
    </template>
  </HeaderCustom>
</template>

<script lang="ts" setup>
import SeletorOpcoesImpressao from '@/views/components/SeletorOpcoesImpressão.vue';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import HeaderCustom from '../components/HeaderCustom.vue';
import CamposLivro from './components/detalhes/CamposLivro.vue';
import CamposCapitulo from './components/detalhes/CamposCapitulo.vue';
import CamposColecaoPeriodico from './components/detalhes/CamposColecaoPeriodico.vue';
import CamposArtigoPeriodico from './components/detalhes/CamposArtigoPeriodico.vue';
import CamposProducaoCientifica from './components/detalhes/CamposProducaoCientifica.vue';
import { computed, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { ConsultaObrasStore } from './store/ConsultaObrasStore';
import { mdiArrowLeft } from '@mdi/js';
import { TipoObra } from '@/constants';
import { useRoute } from 'vue-router/composables';

const store = ConsultaObrasStore();
const route = useRoute();
const { obraTempImpressao: obra, formattedObra } = storeToRefs(store);

onMounted(() => {
  store.consultaDetalhada();
});

watch(formattedObra, async () => {
  store.consultaDetalhada();
});

const canGoBack = computed(() => route.query.back === 'true');

const obraDetails = computed(() => {
  if (!obra.value?.cdTipoObra) {
    return { title: '', component: null };
  }

  const obraMap = {
    [TipoObra.ARTIGO_PERIODICO]: {
      title: 'Artigo de Periódico',
      component: CamposArtigoPeriodico,
    },
    [TipoObra.CAPITULO_LIVRO]: {
      title: 'Capítulo de Livro',
      component: CamposCapitulo,
    },
    [TipoObra.COLECAO_PERIODICO]: {
      title: 'Coleção de Periódico',
      component: CamposColecaoPeriodico,
    },
    [TipoObra.LIVRO]: {
      title: 'Livro',
      component: CamposLivro,
    },
    [TipoObra.PRODUCAO_CIENTIFICA]: {
      title: 'Produção Científica',
      component: CamposProducaoCientifica,
    },
  };

  return obraMap[obra.value?.cdTipoObra];
});
</script>
